module.exports = __webpack_public_path__ + "img/nike-talk-1.aa424fcd.jpg";